import { useState } from 'react';
import { Edit3 } from 'react-feather';
import { toast } from 'react-toastify';
import {
  mensajeErrorGuardado,
  formatearImporte,
  useActualizarPrecio,
} from '../../features/precios';
import TablaServidor from '../../components/tabla/TablaServidor';
import ModalEditarPrecio from '../../components/precios/ModalEditarPrecio';
import { COLUMNAS_PRECIOS, TABLA_PRECIOS } from '../../components/precios/columnasPrecios';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';

const IMPORTES = ['importe_suelto', 'importe_nuevo_suelto', 'precio_ciclo', 'precio_ciclo_nuevo'];

const claveFila = (f) => `${f.empresaId}|${f.idcentro}|${f.codigocurso}`;

const Precios = () => {
  useTituloCabecera('Precios', 'Importes de actividades y ciclos por sede.');
  const [fila, setFila] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [errorGuardado, setErrorGuardado] = useState('');
  const [refresco, setRefresco] = useState(0);
  // La sede de la fila decide la BD a la que se escribe.
  const actualizar = useActualizarPrecio(fila?.empresaId);

  const editar = (seleccionada) => {
    setErrorGuardado('');
    setFila(seleccionada);
    setModalAbierto(true);
  };

  const guardar = (cambios) => {
    setErrorGuardado('');
    actualizar.mutate(
      { idcentro: fila.idcentro, codigocurso: fila.codigocurso, cambios },
      {
        onSuccess: () => {
          toast.success(`Precio de ${fila.codigocurso} actualizado`);
          setModalAbierto(false);
          setRefresco((n) => n + 1);
        },
        onError: (error) => {
          setErrorGuardado(mensajeErrorGuardado(error));
          if (error?.response?.status === 404) setRefresco((n) => n + 1);
        },
      },
    );
  };

  return (
    <>
      <TablaServidor
        tablaKey={TABLA_PRECIOS}
        columnas={COLUMNAS_PRECIOS}
        ruta="listado-precios"
        archivo="precios"
        nombreEntidad="precios"
        placeholder="Buscar por código o nombre de curso…"
        refresco={refresco}
        claveFila={claveFila}
        renderCelda={(col, f) =>
          IMPORTES.includes(col.id) ? formatearImporte(f[col.id]) : undefined
        }
        renderAcciones={(f) => (
          <button
            type="button"
            className="tbl-icono"
            aria-label={`Editar precio de ${f.codigocurso} en ${f.centro}`}
            title="Editar"
            onClick={(e) => {
              e.stopPropagation();
              editar(f);
            }}
          >
            <Edit3 size={14} />
          </button>
        )}
        onFilaClick={editar}
        tituloTarjeta={(f) => `${f.codigocurso} · ${f.centro}`}
      />
      <ModalEditarPrecio
        key={fila ? claveFila(fila) : 'sin-fila'}
        isOpen={modalAbierto}
        fila={fila}
        guardando={actualizar.isPending}
        errorGuardado={errorGuardado}
        onGuardar={guardar}
        onCerrar={() => setModalAbierto(false)}
        onClosed={() => setFila(null)}
      />
    </>
  );
};

export default Precios;
